export type Id = string | number;
export const emptyId: Id = "";
